import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { EmptyTablePlaceholderComponent } from '../../common/empty-table-placeholder.component';
import { ActionListsHistoryComponent } from './action-lists-history.component';
import { ActionListsHistoryStoreService } from './action-lists-history.store.service';
import { BulkActionsProgressReporter } from './bulk-actions-reporter.service';
import { ActionsComponent } from './columns/actions/actions.component';
import { ErrorsComponent } from './columns/errors/errors.component';
import { NumberOfAccountsComponent } from './columns/number-of-accounts';
import { StatusComponent } from './columns/status/status.component';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatCardModule,
    MatTooltipModule,
    TranslateModule,
    GalaxyPipesModule,
    EmptyTablePlaceholderComponent,
  ],
  declarations: [
    ActionListsHistoryComponent,
    NumberOfAccountsComponent,
    StatusComponent,
    ActionsComponent,
    ErrorsComponent,
  ],
  providers: [BulkActionsProgressReporter, ActionListsHistoryStoreService],
  exports: [ActionListsHistoryComponent],
})
export class ActionListsHistoryModule {}
